module.exports = __webpack_public_path__ + "static/media/mr-pay_logo.b2f405fa.svg";